export default __webpack_public_path__ + "static/media/hummus_with_chili_pepper.bfa6f792.jpg";